import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createPurchaseCheck } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BairunPurchaseCheckAdd',
  components: {},
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].statAbbr;
        }
      }

      return '';
    },
    getSellerName: function getSellerName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      title: '',
      action: '',
      oilCodeMap: {},
      rows: [],
      formData: {}
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.formData = _this2.initData();
              _this.title = _this.$route.params.meta.title;
              _this.action = _this.$route.params.action;

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    initData: function initData() {
      return {
        stationId: ''
      };
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onClear: function onClear() {
      this.formData = this.initData();
      this.rows = [];
    },
    onChangeStation: function onChangeStation() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationOilTankInfoList({
                  stationId: _this3.formData.stationId,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 2:
                res = _context3.sent;
                _this3.oilCodeMap = {};
                res.data.list.forEach(function (item) {
                  _this3.oilCodeMap[item.oilCode] = item.oilCode;
                });

                _this3.$forceUpdate();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onAddRow: function onAddRow() {
      var date = new Date().Format('yyyy-MM-dd');

      if (this.rows.length) {
        date = this.rows[this.rows.length - 1].dailyDate;
      }

      this.rows.push({
        'dailyDate': date,
        'oilCode': '',
        'totalGiveInTon': '',
        totalGiveInLiters: ''
      });
    },
    onDelRow: function onDelRow(index) {
      this.rows.splice(index, 1);
    },
    onSave: function onSave() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var valid, index, item, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.formData.stationId) {
                  _context4.next = 3;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '油站不能为空！'
                });

                return _context4.abrupt("return");

              case 3:
                valid = false;
                _context4.t0 = regeneratorRuntime.keys(_this4.rows);

              case 5:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 24;
                  break;
                }

                index = _context4.t1.value;
                item = _this4.rows[index];

                if (item.dailyDate) {
                  _context4.next = 11;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '日期不能为空！'
                });

                return _context4.abrupt("break", 24);

              case 11:
                if (!(item.oilCode === '')) {
                  _context4.next = 14;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '油品不能为空！'
                });

                return _context4.abrupt("break", 24);

              case 14:
                if (item.totalGiveInTon) {
                  _context4.next = 17;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '请填写完整进油吨数！'
                });

                return _context4.abrupt("break", 24);

              case 17:
                if (item.totalGiveInLiters) {
                  _context4.next = 20;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '请填写完整进油升数！'
                });

                return _context4.abrupt("break", 24);

              case 20:
                valid = true;
                item.dailyDate = Number(new Date(item.dailyDate).Format('yyyyMMdd'));
                _context4.next = 5;
                break;

              case 24:
                if (valid) {
                  _context4.next = 26;
                  break;
                }

                return _context4.abrupt("return");

              case 26:
                _context4.next = 28;
                return createPurchaseCheck({
                  'stationId': _this4.formData.stationId,
                  'tankInList': _this4.rows
                });

              case 28:
                res = _context4.sent;

                if (res.code == 0) {
                  _this4.$message({
                    type: 'success',
                    message: '操作成功！'
                  });

                  setTimeout(function () {
                    _this4.goBack();
                  }, 300);
                }

              case 30:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};